<template>
  <div class="closeLoopMointor" ref="closeLoopMointor">
    <div class="bg_box"></div>
    <div class="context_box" @click="openProcessModal">
      <div class="left_part">
        <div class="title_line">
          <div class="title_l">
            今日数据
          </div>
          <div class="title_r">
            数量
          </div>
        </div>
        <ul>
          <li>
            <div class="closeLoop_name">自动触发闭环管理</div>
            <div class="closeLoop_count number">{{workTicketTodayStatistics.totalCount}}</div>
          </li>
          <li>
            <div class="closeLoop_name">人工触发闭环管理</div>
            <div class="closeLoop_count number">{{workTicketTodayStatistics.submitCount}}</div>
          </li>
          <li>
            <div class="closeLoop_name">处理闭环管理</div>
            <div class="closeLoop_count number">{{workTicketTodayStatistics.finishedCount}}</div>
          </li>
        </ul>
      </div>
      <div class="right_part">
        <div class="right_text">闭环管理组织架构图</div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import epdOrganization from '@/modules/cloaeLoopMonitor/epdOrganization';
export default {
  props: ["matrix", "x", "y"],
  components: {
    epdOrganization,
  },
  data() {
    return {
      pageInfo: 'closeLoopMointor.vue',
      computedName: '闭环管理监控系统组件',
      customerId: this.$store.state.customerId,
      workTicketTodayStatistics: {
        finishedCount: '--',
        submitCount: '--',
        totalCount: '--'
      },
    };
  },
  computed: {
    curStyleTypeVal() {
      return this.$store.state.styleType;
    },
    ...mapGetters({
      dialogCompontent3: "getDialogCompontent3",
    }),
  },
  mounted() {
    let w = $(this.$refs.closeLoopMointor).outerWidth();
    let h = $(this.$refs.closeLoopMointor).outerHeight();
    this.$emit("componentInit", {
      w: w,
      h: h,
      matrixType: this.matrix,
      x: this.x,
      y: this.y,
    });

    this.getAbouts();
  },
  methods: {
    async getAbouts() {
      let getWorkTicketTodayStatistics = CONFIG.requestName + this.$apiOpt.getWorkTicketTodayStatistics;
      let res = await this.$apiUtils.get(getWorkTicketTodayStatistics, {
        customerId: this.customerId,
      });
      if (res) {
        this.workTicketTodayStatistics = res;
      }
    },
    openProcessModal() {
      this.$store.commit('dialogStatus3', true);
      this.$popup.open3(
        epdOrganization,
        this.dialogCompontent3,
        {pageTitleName: '闭环管理监控系统'},
        {
        }
      );
      this.$nextTick(() => {
        $(this.dialogCompontent3).addClass("close-loop-monitor");
      });
    },
  },
  beforeUnmount() {
    if ($(this.dialogCompontent3).length > 0) {
      $(this.dialogCompontent3).removeClass('close-loop-monitor');
    }
  },
};
</script>

<style lang="scss" scoped="scoped">
.closeLoopMointor {
  width: 600px;
  height: 250px;
  .bg_box {
    @include bg-box(559px, 181px, "bg.png");
    bottom: 20px;
    position: absolute;
    z-index: 0;
  }
  .context_box {
    z-index: 1;
    display: flex;
    justify-content: space-between;
    margin-top: 32px;
    height: 178px;
    .left_part {
      width: 316px;
      z-index: 2;
      .title_line {
        height: 44px;
        display: flex;
        justify-content: space-between;
        padding: 0px 10px;
        .title_l,
        .title_r {
          font-size: 18px;
          font-weight: 500;
          color: #ffffff;
          line-height: 44px;
          margin-right: 10px;
        }
      }
      ul {
        height: calc(100% - 44px);
        padding-top: 5px;
        li {
          display: flex;
          height: 38px;
          margin-bottom: 5px;
          justify-content: space-between;
          padding: 0px 15px;
          align-items: center;
          .closeLoop_name {
            font-size: 16px;
            color: #ffffff;
            line-height: 38px;
          }
          .closeLoop_count {
            font-size: 22px;
            color: #ffbe54;
            line-height: 38px;
            margin-right: 10px;
          }
        }
      }
    }
    .right_part {
      width: 285px;
      z-index: 2;
      position: relative;
      .right_text {
        position: absolute;
        bottom: 4px;
        left: 60px;
        width: 162px;
        height: 25px;
        font-size: 18px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #bcebff;
        line-height: 25px;
      }
    }
  }
}
</style>
